/* js/components/mediaPlayers/BandcampTrack.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_style,
	src_url_equal
} from "svelte/internal";

import { onMount } from 'svelte';

function create_fragment(ctx) {
	let iframe;
	let iframe_src_value;

	return {
		c() {
			iframe = element("iframe");
			set_style(iframe, "border", "0");
			set_style(iframe, "width", "100%");
			set_style(iframe, "height", "42px");
			if (!src_url_equal(iframe.src, iframe_src_value = /*src*/ ctx[0])) attr(iframe, "src", iframe_src_value);
			attr(iframe, "seamless", "");
		},
		m(target, anchor) {
			insert(target, iframe, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*src*/ 1 && !src_url_equal(iframe.src, iframe_src_value = /*src*/ ctx[0])) {
				attr(iframe, "src", iframe_src_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(iframe);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { trackId } = $$props;
	let src = "";

	onMount(() => {
		$$invalidate(0, src = `https://bandcamp.com/EmbeddedPlayer/size=small/bgcol=ffffff/linkcol=0687f5/track=${trackId}/transparent=true/`);
	});

	$$self.$$set = $$props => {
		if ('trackId' in $$props) $$invalidate(1, trackId = $$props.trackId);
	};

	return [src, trackId];
}

class BandcampTrack extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { trackId: 1 });
	}
}

export default BandcampTrack;